import { render, staticRenderFns } from "./demo2.vue?vue&type=template&id=6bf955a4&scoped=true"
import script from "./demo2.vue?vue&type=script&lang=js"
export * from "./demo2.vue?vue&type=script&lang=js"
import style0 from "./demo2.vue?vue&type=style&index=0&id=6bf955a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf955a4",
  null
  
)

export default component.exports